import React, { useState, useEffect, useRef } from 'react';
import './pai.css';
import MarkdownParagraph from './MarkedDownParagraph';
import { ReactComponent as Character } from '../landing/character.svg';

function PaiSidebar({
  user_id,
  topic,
  task_number,
  is_task,
  user_code,
  conversation,
  setConversation,
  isSidebarOpen,
  setIsSidebarOpen,
  course_name
}) {
  const [sessionId, setSessionId] = useState('');
  const [bubbleVisible, setBubbleVisible] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    if (bubbleVisible) {
      setBubbleVisible(false);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    const updateSessionId = async () => {
      // first get session id
      const response_to_get_session_id = await fetch('api/chat/sessions', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: user_id,
          topic: topic,
          task_number: task_number,
          is_task: is_task,
          course_name: course_name
        }),
      });
      const data_session = await response_to_get_session_id.json();
      setSessionId(data_session.session_id)
      setConversation(data_session.messages)
    }
    updateSessionId()

  }, [topic, task_number, user_id])

  useEffect(() => {
    if (isSidebarOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isSidebarOpen]);

  useEffect(() => {
    function handleEscape(event) {
      if (event.key === 'Escape' && isSidebarOpen) {
        setIsSidebarOpen(false);
      }
    }
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isSidebarOpen]);

  useEffect(() => {
    if (isSidebarOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isSidebarOpen]);

  const sendMessageEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      sendMessageFunc()
    }
  };

  const sendMessageButtom = async () => {
    sendMessageFunc()
  };

  const sendMessageFunc = async () => {

    const message = inputRef.current.value;
    inputRef.current.value = "";
    if (message.trim() === '') return;

    const userMessage = { role: 'user', message: message };
    setConversation((prevConversation) => [...prevConversation, userMessage]);

    try {

      // send message
      const response = await fetch('api/chat/messages', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
           session_id: sessionId,
           message: userMessage.message,
           user_code: user_code,
        }),
      });

      const data = await response.json();
      const assistantMessage = { role: 'assistant', message: data.bot_message };

      setConversation((prevConversation) => [
        ...prevConversation,
        assistantMessage,
      ]);
    } catch (error) {
      const errorMessage = {
        role: 'assistant',
        message: '## Произошла ошибка, решаем..',
      };
      setConversation((prevConversation) => [
        ...prevConversation,
        errorMessage,
      ]);
    }
  };

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setBubbleVisible(true);
    }, 10000);

    const hideTimer = setTimeout(() => {
      setBubbleVisible(false);
    }, 30000);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <div className="pai-sidebar-container">
      <div className="pai-button-wrapper">
        <button className="pai-button" onClick={toggleSidebar}>
          <Character style={{ height: '15vh', width: 'auto' }}/>
        </button>
        {bubbleVisible && (
          <div className="speech-bubble fade-in-pai">
            Чем-нибудь помочь?
          </div>
        )}
      </div>
      {isSidebarOpen && (
        <div className="pai-sidebar">
          <button className="close-button" onClick={toggleSidebar}>
            ✖
          </button>
          <div className="sidebar-content">
            <h2>Как я могу помочь тебе?</h2>
            {conversation && (
              <div className="conversation">
                {conversation.map((msg, index) => (
                  <div
                    key={index}
                    className={`message-box ${
                      msg.role === 'user' ? 'user-message' : 'assistant-message'
                    }`}
                  >
                  <MarkdownParagraph markdownText={msg.message} />
                  </div>
                ))}
              </div>
            )}
            <div className="input-container">
              <textarea
                ref={inputRef}
                rows={1}
                placeholder="Напиши свой вопрос"
                onKeyDown={sendMessageEnter}
                className="sidebar-input"
              />
              <button className="send-btn" onClick={sendMessageButtom}>
                >
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PaiSidebar;
